export default {"src":"/_next/static/media/whatsApp.d9b7368f.gif","height":640,"width":640};